{
  "version": 1,
  "asset_id": "855f2c53-d937-4131-af09-b67db7cf867b",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/855f2c53-d937-4131-af09-b67db7cf867b/house-wash-100-off.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/855f2c53-d937-4131-af09-b67db7cf867b/house-wash-100-off.mp4",
  "original_filename": "house-wash-100-off.mp4",
  "size": 2743274,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:37:11Z"
}
